export default __webpack_public_path__ + "691b18250e976fc99c7af5cb734b37e4.jpg";